import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { ActionBanner } from "../../../common/components/functional/actionBanner/ActionBanner";
import { Box, CircularProgress, Typography } from "@mui/material";
import { ActionButton } from "../../talentProfile/styles";
import { useTranslation } from "react-i18next";
import { sendWageReports } from "./wageReportsSlice";
import { isFulfilled } from "@reduxjs/toolkit";
import useMessage from "../../../hooks/useMessage";

type Props = {
  selectedItems: string[];
  emptyItems: () => void;
};

export const WageReportsActionBanner = ({
  selectedItems,
  emptyItems,
}: Props) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { sendMessage } = useMessage();

  const { status } = useAppSelector((state) => state.wageReports);
  const isLoading = status === "pending";

  const resendWageReports = () => {
    dispatch(sendWageReports(selectedItems)).then((action) => {
      if (isFulfilled(action)) {
        emptyItems();
        sendMessage(t("payslips:wageReportsSent"), "success");
      }
    });
  };

  return (
    <ActionBanner isOpen={selectedItems.length > 0}>
      <Box
        display="inherit"
        sx={{
          alignItems: "center",
        }}
      >
        <Typography variant="secondary" pr={3}>
          {`${t("payslips:doForSelected")} (${selectedItems.length})`}
        </Typography>
        <ActionButton
          variant="outlined"
          disabled={isLoading}
          onClick={resendWageReports}
        >
          <Box></Box>
          {isLoading ? (
            <CircularProgress sx={{ margin: "0px 16px" }} size={24} />
          ) : (
            t("payslips:sendWageReportAgain")
          )}
        </ActionButton>
      </Box>
    </ActionBanner>
  );
};
